<navigation [page]="'Theme Admin'"></navigation>

<main>
    <dx-tab-panel
            [animationEnabled]="true"
            [swipeEnabled]="false"
            (onSelectionChanging)="onTabChanging($event)">

        <!-- ================= THEMES TAB ================= -->
        <dxi-item title="Themes">
            <div class="search-container">
                <dx-text-box
                        placeholder="Search theme..."
                        [(value)]="searchQuery"
                        valueChangeEvent="keyup"
                        valueChangeTimeout="200"
                        (onValueChanged)="onSearch()">
                </dx-text-box>
            </div>

            <div class="grid">
                @for(theme of filteredThemes; track theme.id){
                    <div class="grid-item" [ngClass]="{'invalid-theme': theme.idsFileId?false:true}">
                        <div class="card-icon" >
                            <img [src]="getThemePreview(theme.id)" (error)="$any($event.target).src='assets/icons/acfr.svg'" [alt]="theme.name">
                        </div>
                        <h3>{{theme.name}}</h3>
                        <div class="card-container">
                            <div class="desc">
                                {{theme.type}}
                            </div>
                            <div class="buttons">
                                <dx-button icon="edit" type="default" stylingMode="outlined" (onClick)="openEditDialog(theme.id)"></dx-button>
                                <dx-button type="danger" icon="trash" (onClick)="removeTheme = theme"></dx-button>
                            </div>
                        </div>
                    </div>
                }
            </div>

            <div class="aling-end">
                <dx-button
                        icon="add"
                        text="New theme"
                        type="default"
                        stylingMode="contained"
                        (onClick)="openCreatePopup()">
                </dx-button>
            </div>
        </dxi-item>

        <!-- ================= CHART TEMPLATES TAB ================= -->
        <dxi-item title="Chart Templates"></dxi-item>

        <!-- ================= MDFM TEMPLATES TAB ================= -->
        <dxi-item title="MDFM CSS Templates">
            <div class="search-container">
                <dx-text-box
                        placeholder="Search template..."
                        valueChangeEvent="keyup"
                        valueChangeTimeout="200"
                        (onValueChanged)="onCssSearch($event)">
                </dx-text-box>
            </div>
            <div class="grid">
                @for(template of filteredCssTemplates; track template.id){
                    <div class="grid-item">
                        <div class="buttons">
                            <dx-button icon="edit" type="default" stylingMode="outlined" (onClick)="openEditCssDialog(template.id)"></dx-button>
                            <dx-button type="danger" icon="trash" (onClick)="removeCssTemplate = template"></dx-button>
                        </div>

                        <h3>{{template.name}}</h3>
                    </div>
                }
            </div>

            <div class="aling-end">
                <dx-button
                        icon="add"
                        text="New template"
                        type="default"
                        stylingMode="contained"
                        (onClick)="openCreateCssPopup()">
                </dx-button>
            </div>
        </dxi-item>

    </dx-tab-panel>
</main>

<!-- ================= REMOVE THEME POPUP ================= -->
@if(removeTheme){
    <dx-popup
            [title]="'Remove Theme'"
            [visible]="true"
            [height]="200"
            [width]="500"
            (visibleChange)="removeTheme=null">

        <div *dxTemplate="let data of 'content'" class="column">
            <div>
                Are you sure you want to remove the theme
                <b>{{removeTheme.name}}</b>? This action cannot be undone.
            </div>
        </div>

        <dxi-popup-toolbar-item toolbar="bottom" location="after">
            <div *dxTemplate>
                <dx-button (onClick)="removeTheme = null">Cancel</dx-button>
            </div>
        </dxi-popup-toolbar-item>

        <dxi-popup-toolbar-item toolbar="bottom" location="after">
            <div *dxTemplate>
                <dx-button
                        type="danger"
                        (onClick)="remove(removeTheme.id)">
                    Remove
                </dx-button>
            </div>
        </dxi-popup-toolbar-item>
    </dx-popup>
}

<!-- ================= ADD / EDIT THEME ================= -->
@if(showForm) {
    <add-edit-component
            [(visible)]="showForm"
            [theme]="selectedTheme"
            (onFinished)="showForm = false; listThemes()">
    </add-edit-component>
}

<!-- ================= ADD / EDIT MDFM CSS TEMPLATE ================= -->
@if(showCssForm) {
    <add-edit-css-component
            [(visible)]="showCssForm"
            [template]="selectedCssTemplate"
            (onFinished)="showCssForm = false; listCssTemplates()">
    </add-edit-css-component>
}

<!-- ================= CHART PANEL ================= -->
@if(showChartForm) {
    <chart-panel-component
            [(visible)]="showChartForm"
            [template]="selectedChartTemplate"
            (onFinished)="showChartForm = false">
    </chart-panel-component>
}

<!-- ================= REMOVE MDFM CSS POPUP ================= -->
@if(removeCssTemplate){
    <dx-popup
            [title]="'Remove MDFM CSS Template'"
            [visible]="true"
            [height]="200"
            [width]="500"
            (visibleChange)="removeCssTemplate=null">

        <div *dxTemplate="let data of 'content'" class="column">
            <div>
                Are you sure you want to remove the template
                <b>{{removeCssTemplate.name}}</b>? This action cannot be undone.
            </div>
        </div>

        <dxi-popup-toolbar-item toolbar="bottom" location="after">
            <div *dxTemplate>
                <dx-button (onClick)="removeCssTemplate = null">Cancel</dx-button>
            </div>
        </dxi-popup-toolbar-item>

        <dxi-popup-toolbar-item toolbar="bottom" location="after">
            <div *dxTemplate>
                <dx-button
                        type="danger"
                        (onClick)="removeTemplate(removeCssTemplate.id)">
                    Remove
                </dx-button>
            </div>
        </dxi-popup-toolbar-item>
    </dx-popup>
}
